import { common } from './common';

export const prices = {
  common
};
